<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 style="text-align: left;font-size: 26px">eAssist Holland Profile</h1>
                        <p class="mt10">Each question is an opportunity for you to describe the kinds of things you as a person can do
                        ,might like to do or the action that most fits you.When you have selected all the choices that describe
                        you, click "submit" to finish your assessment.</p>

                        <div class="borderTop">Are you:</div>
                        <div class="subjectBox">
                            <el-checkbox v-model="form.sub0" :disabled="isAdmin">Practical</el-checkbox>
                            <el-checkbox v-model="form.sub1" :disabled="isAdmin">Athletic</el-checkbox>
                            <el-checkbox v-model="form.sub2" :disabled="isAdmin">Straight forward</el-checkbox>
                            <el-checkbox v-model="form.sub3" :disabled="isAdmin">Mechanically inclined</el-checkbox>
                            <el-checkbox v-model="form.sub4" :disabled="isAdmin">A nature lover</el-checkbox>
                            <el-checkbox v-model="form.sub5" :disabled="isAdmin">Good with tools and machinery</el-checkbox>
                            <el-checkbox v-model="form.sub6" :disabled="isAdmin">Inquisitive </el-checkbox>
                            <el-checkbox v-model="form.sub7" :disabled="isAdmin">Analytical</el-checkbox>
                            <el-checkbox v-model="form.sub8" :disabled="isAdmin">Scientific</el-checkbox>
                            <el-checkbox v-model="form.sub9" :disabled="isAdmin">Observant</el-checkbox>
                            <el-checkbox v-model="form.sub10" :disabled="isAdmin">Precise</el-checkbox>
                            <el-checkbox v-model="form.sub11" :disabled="isAdmin">Creative</el-checkbox>
                            <el-checkbox v-model="form.sub12" :disabled="isAdmin">Intuitive</el-checkbox>
                            <el-checkbox v-model="form.sub13" :disabled="isAdmin">Imaginative</el-checkbox>
                            <el-checkbox v-model="form.sub14" :disabled="isAdmin">Innovative</el-checkbox>
                            <el-checkbox v-model="form.sub15" :disabled="isAdmin">An individualist</el-checkbox>
                            <el-checkbox v-model="form.sub16" :disabled="isAdmin">Friendly</el-checkbox>
                            <el-checkbox v-model="form.sub17" :disabled="isAdmin">Helpful</el-checkbox>
                            <el-checkbox v-model="form.sub18" :disabled="isAdmin">Idealistic</el-checkbox>
                            <el-checkbox v-model="form.sub19" :disabled="isAdmin">Insightful</el-checkbox>
                            <el-checkbox v-model="form.sub20" :disabled="isAdmin">Outgoing</el-checkbox>
                            <el-checkbox v-model="form.sub21" :disabled="isAdmin">Understanding</el-checkbox>
                            <el-checkbox v-model="form.sub22" :disabled="isAdmin">Self-confident</el-checkbox>
                            <el-checkbox v-model="form.sub23" :disabled="isAdmin">Assertive</el-checkbox>
                            <el-checkbox v-model="form.sub24" :disabled="isAdmin">Sociable</el-checkbox>
                            <el-checkbox v-model="form.sub25" :disabled="isAdmin">Persuasive</el-checkbox>
                            <el-checkbox v-model="form.sub26" :disabled="isAdmin">Enthusiastic</el-checkbox>
                            <el-checkbox v-model="form.sub27" :disabled="isAdmin">Energetic</el-checkbox>
                            <el-checkbox v-model="form.sub28" :disabled="isAdmin">Well groomed </el-checkbox>
                            <el-checkbox v-model="form.sub29" :disabled="isAdmin">Accurate</el-checkbox>
                            <el-checkbox v-model="form.sub30" :disabled="isAdmin">Numerically inclined</el-checkbox>
                            <el-checkbox v-model="form.sub31" :disabled="isAdmin">Methodical</el-checkbox>
                            <el-checkbox v-model="form.sub32" :disabled="isAdmin">Conscientious</el-checkbox>
                            <el-checkbox v-model="form.sub33" :disabled="isAdmin">Efficient</el-checkbox>
                        </div>
                        <div class="subject">Can you:</div>
                        <div class="subjectBox">
                            <el-checkbox v-model="form.sub34" :disabled="isAdmin">Fix electrical things</el-checkbox>
                            <el-checkbox v-model="form.sub35" :disabled="isAdmin">Solve mechanical problems</el-checkbox>
                            <el-checkbox v-model="form.sub36" :disabled="isAdmin">Pitch a tent</el-checkbox>
                            <el-checkbox v-model="form.sub37" :disabled="isAdmin">Play a sport</el-checkbox>
                            <el-checkbox v-model="form.sub38" :disabled="isAdmin">Read a blueprint</el-checkbox>
                            <el-checkbox v-model="form.sub39" :disabled="isAdmin">Work on cars</el-checkbox>
                            <el-checkbox v-model="form.sub40" :disabled="isAdmin">Think abstractly</el-checkbox>
                            <el-checkbox v-model="form.sub41" :disabled="isAdmin">Solve math problems </el-checkbox>
                            <el-checkbox v-model="form.sub42" :disabled="isAdmin">Understand physical theories</el-checkbox>
                            <el-checkbox v-model="form.sub43" :disabled="isAdmin">Do complex calculations</el-checkbox>
                            <el-checkbox v-model="form.sub44" :disabled="isAdmin">Use a microscope</el-checkbox>
                            <el-checkbox v-model="form.sub45" :disabled="isAdmin">Analyze data</el-checkbox>
                            <el-checkbox v-model="form.sub46" :disabled="isAdmin">Sketch, draw, paint</el-checkbox>
                            <el-checkbox v-model="form.sub47" :disabled="isAdmin">Play a musical instrument</el-checkbox>
                            <el-checkbox v-model="form.sub48" :disabled="isAdmin">Write stories, poetry, music, sing, act, dance</el-checkbox>
                            <el-checkbox v-model="form.sub49" :disabled="isAdmin">Design fashions or interiors</el-checkbox>
                            <el-checkbox v-model="form.sub50" :disabled="isAdmin">Teach/train others</el-checkbox>
                            <el-checkbox v-model="form.sub51" :disabled="isAdmin">Express yourself clearly</el-checkbox>
                            <el-checkbox v-model="form.sub52" :disabled="isAdmin">Lead a group discussion</el-checkbox>
                            <el-checkbox v-model="form.sub53" :disabled="isAdmin">Mediate disputes</el-checkbox>
                            <el-checkbox v-model="form.sub54" :disabled="isAdmin">Plan and supervise an activity</el-checkbox>
                            <el-checkbox v-model="form.sub55" :disabled="isAdmin">Cooperate well with others</el-checkbox>
                            <el-checkbox v-model="form.sub56" :disabled="isAdmin">Initiate projects</el-checkbox>
                            <el-checkbox v-model="form.sub57" :disabled="isAdmin">convince people to do things your way</el-checkbox>
                            <el-checkbox v-model="form.sub58" :disabled="isAdmin">Sell things or promote ideas</el-checkbox>
                            <el-checkbox v-model="form.sub59" :disabled="isAdmin">Give talks or speeches</el-checkbox>
                            <el-checkbox v-model="form.sub60" :disabled="isAdmin">Organize activities and events</el-checkbox>
                            <el-checkbox v-model="form.sub61" :disabled="isAdmin">Lead a group</el-checkbox>
                            <el-checkbox v-model="form.sub62" :disabled="isAdmin">Work well within a system</el-checkbox>
                            <el-checkbox v-model="form.sub63" :disabled="isAdmin">Do a lot of paper work in a short time</el-checkbox>
                            <el-checkbox v-model="form.sub64" :disabled="isAdmin">Keep accurate records</el-checkbox>
                            <el-checkbox v-model="form.sub65" :disabled="isAdmin">Use a computer terminal</el-checkbox>
                            <el-checkbox v-model="form.sub66" :disabled="isAdmin">Write effective business letters</el-checkbox>
                        </div>
                        <div class="subject">Do you like to:</div>
                        <div class="subjectBox">
                            <el-checkbox v-model="form.sub67" :disabled="isAdmin">Tinker with mechanics</el-checkbox>
                            <el-checkbox v-model="form.sub68" :disabled="isAdmin">Work outdoors</el-checkbox>
                            <el-checkbox v-model="form.sub69" :disabled="isAdmin">Be physically active</el-checkbox>
                            <el-checkbox v-model="form.sub70" :disabled="isAdmin">use your hands</el-checkbox>
                            <el-checkbox v-model="form.sub71" :disabled="isAdmin">Build things</el-checkbox>
                            <el-checkbox v-model="form.sub72" :disabled="isAdmin">Explore ideas</el-checkbox>
                            <el-checkbox v-model="form.sub73" :disabled="isAdmin">use computers</el-checkbox>
                            <el-checkbox v-model="form.sub74" :disabled="isAdmin">Work independently</el-checkbox>
                            <el-checkbox v-model="form.sub75" :disabled="isAdmin">Perform lab experiments</el-checkbox>
                            <el-checkbox v-model="form.sub76" :disabled="isAdmin">Read scientific or technical magazines</el-checkbox>
                            <el-checkbox v-model="form.sub77" :disabled="isAdmin">Attend concerts, theaters, art exhibits</el-checkbox>
                            <el-checkbox v-model="form.sub78" :disabled="isAdmin">Read fiction, plays, poetry</el-checkbox>
                            <el-checkbox v-model="form.sub79" :disabled="isAdmin">Work on crafts</el-checkbox>
                            <el-checkbox v-model="form.sub80" :disabled="isAdmin">Take photographs</el-checkbox>
                            <el-checkbox v-model="form.sub81" :disabled="isAdmin">Express yourself creatively</el-checkbox>
                            <el-checkbox v-model="form.sub82" :disabled="isAdmin">Work in groups</el-checkbox>
                            <el-checkbox v-model="form.sub83" :disabled="isAdmin">Help people with problems</el-checkbox>
                            <el-checkbox v-model="form.sub84" :disabled="isAdmin">Participate in meetings</el-checkbox>
                            <el-checkbox v-model="form.sub85" :disabled="isAdmin">Do volunteer service</el-checkbox>
                            <el-checkbox v-model="form.sub86" :disabled="isAdmin">Work with young people</el-checkbox>
                            <el-checkbox v-model="form.sub87" :disabled="isAdmin">Play team sports</el-checkbox>
                            <el-checkbox v-model="form.sub88" :disabled="isAdmin">Make decisions affecting others</el-checkbox>
                            <el-checkbox v-model="form.sub89" :disabled="isAdmin">Be elected to office</el-checkbox>
                            <el-checkbox v-model="form.sub90" :disabled="isAdmin">win a leadership or sales award</el-checkbox>
                            <el-checkbox v-model="form.sub91" :disabled="isAdmin">Start your own political campaign</el-checkbox>
                            <el-checkbox v-model="form.sub92" :disabled="isAdmin">Meet important people</el-checkbox>
                            <el-checkbox v-model="form.sub93" :disabled="isAdmin">Follow clearly defined procedures</el-checkbox>
                            <el-checkbox v-model="form.sub94" :disabled="isAdmin">Use data processing equipment </el-checkbox>
                            <el-checkbox v-model="form.sub95" :disabled="isAdmin">Work with numbers</el-checkbox>
                            <el-checkbox v-model="form.sub96" :disabled="isAdmin">Type or take shorthand</el-checkbox>
                            <el-checkbox v-model="form.sub97" :disabled="isAdmin">Be responsible for details</el-checkbox>
                        </div>
                        <div class="btnLayout">
                            <el-button class="yellowBtn" @click="submit" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                        </div>
                    </div>
                </div>
                <div  v-if="showResult&&hasFinished">
                    <hollandChart :holland="holland" ref="holland"></hollandChart>
                    <el-button class="yellowBtn" style="margin-top: 20px;width: 80px;margin-bottom: 20px" @click="goPre">Back</el-button>
                </div>

            </section>
        </div>
        <el-dialog title="warning" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goPre">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible">
            <div>Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="confirmForm">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader";
    import Side from "../../components/Aside";
    import hollandChart from "./hollandChart";
    import { chat2Ascii } from "../../../static/js/util";
    export default {
        name: "hollandTest",
        components:{
            ApplyHeader,Side,hollandChart
        },
        data(){
            return{
                showResult:false,
                hasFinished:false,//代表页面初始化完毕,比如是显示做题结果结果还是显示题目
                exitVisible:false,
                confirmVisible:false,
                form:{
                },
                isAdmin:false,
                holland:[0,0,0,0,0,0],
                loading:false,
            }
        },
        mounted() {
            this.getData()
        },
        computed:{
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            goPre(){
                this.$router.go(-1)
            },
            addHolland(){
                var a = [[0,5],[34,39],[67,71]]//Realistic
                var b = [[5,10],[39,45],[72,76]]//Investigative
                var c = [[11,15],[46,49],[77,81]]//Artistic
                var d = [[16,21],[50,55],[82,87]]//Social
                var e = [[22,27],[56,61],[88,92]]//Enterprising
                var f = [[28,33],[62,66],[93,97]]//Conventional
                var list = [a,b,c,d,e,f]
                for(var i = 0;i<list.length;i++){
                    var item = list[i]
                    for(var j=0;j<item.length;j++){
                        var child = item[j]
                        for(var k = child[0];k<=child[1];k++){
                            if(this.form['sub'+k])
                                this.holland[i]++
                        }
                    }
                }
                // this.holland = JSON.parse(JSON.stringify(this.holland))
                // if(this.$refs.holland)this.$refs.holland.update()
                var params = {}
                params.email=localStorage.getItem('email')
                params.realistic = this.holland[0];
                params.investigative = this.holland[1];
                params.artistic = this.holland[2];
                params.social = this.holland[3];
                params.enterprising = this.holland[4];
                params.conventional = this.holland[5];
                this.loading=true
                this.$axios.post(this.$URL.hollandTestUrl,params).then(res=>{
                    this.loading=false
                    if(res&&res.code===0){
                        console.log('holland',res)
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            cancel(){
                this.exitVisible=true
            },
            confirmForm(){
                this.holland=[0,0,0,0,0,0]
                this.showResult=true
                this.confirmVisible=false
                this.addHolland()
            },
            submit(){
                this.confirmVisible=true
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    this.isAdmin=true
                    this.showResult=true
                }else{
                    this.isAdmin=false
                }
                this.getHollandTestData()
            },
            getHollandTestData(){
                var email
                if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                     email = this.$route.query.email
                    var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.isAdmin=true
                }else{
                    email = localStorage.getItem('email')
                }
                this.loading=true
                this.$axios.get(this.$URL.hollandTestUrl,{params:{email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        console.log('bbb',res.data)
                        var data = res.data
                        if(data){
                            this.showResult=true
                            this.holland[0] = data.realistic
                            this.holland[1] = data.investigative
                            this.holland[2] = data.artistic
                            this.holland[3] = data.social
                            this.holland[4] = data.enterprising
                            this.holland[5] = data.conventional
                            if(this.$refs&&this.$refs.holland)this.$refs.holland.update()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            }
        },
        watch:{
            '$route'(to,from){
                console.log(from)
                if(to.path==='/hollandTest'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .el-checkbox{
        width: 29%;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    .borderTop{
        border: 1px solid #cccccc;
        font-weight: bold;
        padding-left: 10px;
        margin-top: 10px
    }
    .subjectBox{
        border-left: 1px solid #cccccc;
        border-right: 1px solid #cccccc;
        border-bottom: 1px solid #cccccc;
        padding: 10px;
        font-size: 12px
    }
    .subject{
        font-weight: bold;
        border-left: 1px solid #cccccc;
        border-right: 1px solid #cccccc;
        border-bottom: 1px solid #cccccc;
        padding-left: 10px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>